<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style lang="stylus">

</style>
<script>
    export default {
      data () {
          return {

          };
      },
      methods: {

      },
      created() {
        // console.log('GO');
      },
    };
</script>
